import { graphql, useStaticQuery } from "gatsby"

const usePrefecturesCollection = () => {
  const data = useStaticQuery(graphql`
    query AllCollectionPrefecturesQuery {
      prefectures: allCollectionPrefectures {
        nodes {
          id
          district {
            value
          }
          url
        }
      }
    }
  `)

  return data.prefectures.nodes
}

export default usePrefecturesCollection
